import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'tokko.propiedades',
        path: `${APP_PREFIX_PATH}/propiedades`,
        component: React.lazy(() => import('views/app-views/tokko/propiedades')),
    },
    {
        key: 'tokko.propiedad-detalle',
        path: `${APP_PREFIX_PATH}/propiedades/:id`,
        component: React.lazy(() => import('views/app-views/tokko/propiedades/detalle')),
    },
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'admin.users',
        path: `${APP_PREFIX_PATH}/admin/users`,
        component: React.lazy(() => import('views/app-views/admin/users')),
    },
    {
        key: 'admin.sync',
        path: `${APP_PREFIX_PATH}/admin/sync`,
        component: React.lazy(() => import('views/app-views/admin/sync')),
    },
    {
        key: 'user.profile',
        path: `${APP_PREFIX_PATH}/user/profile`,
        component: React.lazy(() => import('views/app-views/user/default')),
    },
    {
        key: 'user.update-password',
        path: `${APP_PREFIX_PATH}/user/update-password`,
        component: React.lazy(() => import('views/app-views/user/default')),
    },
     {
        key: 'marketing.catalogos',
        path: `${APP_PREFIX_PATH}/marketing/catalogo`,
        component: React.lazy(() => import('views/app-views/marketing/catalogos')),
    },
    {
        key: 'marketing.catalogos.create',
        path: `${APP_PREFIX_PATH}/marketing/catalogo/create`,
        component: React.lazy(() => import('views/app-views/marketing/catalogos/create')),
    },
     {
        key: 'marketing.catalogos.update',
        path: `${APP_PREFIX_PATH}/marketing/catalogo/update/:id`,
        component: React.lazy(() => import('views/app-views/marketing/catalogos/update')),
    },
    {
        key: 'marketing.campanias',
        path: `${APP_PREFIX_PATH}/marketing/campanias`,
        component: React.lazy(() => import('views/app-views/marketing/campanias')),
    },
    {
        key: 'tokko.contactosWeb',
        path: `${APP_PREFIX_PATH}/contactos-web`,
        component: React.lazy(() => import('views/app-views/tokko/contactos-web')),
    },
    // URLs viejas con el segmento /tokko (y la seccion "Informes"): redirigen
    // a las nuevas para no romper favoritos. Ver views/app-views/tokko/legacy-redirect.js.
    ...['tokko/propiedades', 'tokko/propiedades/:id', 'tokko/contactos-web', 'tokko/informes'].map((legacy) => ({
        key: `legacy.${legacy}`,
        path: `${APP_PREFIX_PATH}/${legacy}`,
        component: React.lazy(() => import('views/app-views/tokko/legacy-redirect')),
    })),
    // --- Subsistema de leads (migrado desde leads-system) ---
    {
        key: 'leads.tag-dimensions',
        path: `${APP_PREFIX_PATH}/leads/tag-dimensions`,
        component: React.lazy(() => import('views/app-views/leads/tag-dimensions')),
    },
    {
        key: 'leads.attribute-fields',
        path: `${APP_PREFIX_PATH}/leads/attribute-fields`,
        component: React.lazy(() => import('views/app-views/leads/attribute-fields')),
    },
    {
        key: 'leads.data-sources',
        path: `${APP_PREFIX_PATH}/leads/data-sources`,
        component: React.lazy(() => import('views/app-views/leads/data-sources')),
    },
    {
        key: 'leads.settings',
        path: `${APP_PREFIX_PATH}/leads/settings`,
        component: React.lazy(() => import('views/app-views/leads/settings')),
    },
    {
        key: 'leads.queues',
        path: `${APP_PREFIX_PATH}/leads/queues`,
        component: React.lazy(() => import('views/app-views/leads/queues')),
    },
    {
        key: 'leads.contacts',
        path: `${APP_PREFIX_PATH}/leads/contacts`,
        component: React.lazy(() => import('views/app-views/leads/contacts')),
    },
    {
        key: 'leads.messages',
        path: `${APP_PREFIX_PATH}/leads/messages`,
        component: React.lazy(() => import('views/app-views/leads/messages')),
    },
    {
        key: 'leads.web-forms-settings',
        path: `${APP_PREFIX_PATH}/leads/web-forms/settings`,
        component: React.lazy(() => import('views/app-views/leads/web-forms/settings')),
    },
    {
        key: 'leads.web-forms',
        path: `${APP_PREFIX_PATH}/leads/web-forms`,
        component: React.lazy(() => import('views/app-views/leads/web-forms')),
    },
    {
        key: 'leads.contact-detail',
        path: `${APP_PREFIX_PATH}/leads/contacts/:id`,
        component: React.lazy(() => import('views/app-views/leads/contacts/detail')),
    },
    {
        key: 'leads.list',
        path: `${APP_PREFIX_PATH}/leads`,
        component: React.lazy(() => import('views/app-views/leads/list')),
    },
    {
        key: 'leads.detail',
        path: `${APP_PREFIX_PATH}/leads/:id`,
        component: React.lazy(() => import('views/app-views/leads/detail')),
    },
]